export const hasRole = (appUser, role) => {
    if (appUser && appUser.roles && appUser.roles.length > 0)
    {
        return appUser.roles.indexOf(role) !== -1;

    }
    return false;
}